//import { TABSTART } from '@/utils/constants';
import React, { JSX } from 'react';
import { useEffect } from 'react';
import { CloseButton, Modal } from 'react-bootstrap';

interface GenericModalSchema {
  modalState: boolean;
  handler: () => void;
  children: React.ReactNode; // modal body
  showFooter: boolean;
  footerNode?: React.ReactNode;
  height?: string;
  width?: string;
  noCloseButton?: boolean;
  backDrop?: boolean;
  fixedWidth?: string;
  backgroundColor?:string;
  bodyPadding?:string;
  id?:string;
}

const GenericModal = ({
  modalState,
  handler,
  showFooter,
  footerNode,
  children,
  width,
  height,
  noCloseButton,
  backDrop,
  fixedWidth,
  backgroundColor,
  bodyPadding,
  id
}: GenericModalSchema): JSX.Element => {
  useEffect(() => {
    const elem: any = document && document.querySelector('.modal-dialog');
    if (elem) {
      elem.style.maxWidth = width;
      elem.style.padding = '0';
      elem.style.width = fixedWidth;
    }
    const elem1: any = document.querySelector('.modal-content');
    if (elem1) {
      elem1.style.minHeight = height;
      elem1.style.backgroundColor=backgroundColor
    }
    const elem2: any = document.querySelector('.modal-body');
    if(elem2 && bodyPadding){
      elem2.style.padding =bodyPadding;
    }
  }, [height]);

  return (
    <Modal
      centered
      contentClassName={`${id==='mobile-benefits' ? 'benefits-container':id==='table-product'?'table-product':''}`}
      show={modalState}
      onHide={handler}
      backdrop={backDrop ? backDrop : 'static'}
      keyboard={false}
      dialogClassName='sr-custom-modal'
    >
      <Modal.Header>
        <div style={{ display: noCloseButton ? 'none' : '' }}>
          <CloseButton className='sr-modal-close' onClick={handler} />
        </div>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      {showFooter && <Modal.Footer>{footerNode}</Modal.Footer>}
    </Modal>
  );
};

export default GenericModal;
